export default "__VITE_ASSET__DitI2jWS__"